import { render, staticRenderFns } from "./VUserCouponCode.vue?vue&type=template&id=45f53f2e&scoped=true"
import script from "./VUserCouponCode.vue?vue&type=script&lang=ts"
export * from "./VUserCouponCode.vue?vue&type=script&lang=ts"
import style0 from "./VUserCouponCode.vue?vue&type=style&index=0&id=45f53f2e&prod&lang=scss&scoped=true"
import style1 from "./VUserCouponCode.vue?vue&type=style&index=1&id=45f53f2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f53f2e",
  null
  
)

export default component.exports